/**
 * Wishlist functionality using event delegation
 * This single script handles all wishlist buttons on the page
 */
(function() {
  'use strict';

  // Initialize wishlist buttons on page load
  function initWishlistButtons() {
    const wishlistButtons = document.querySelectorAll('.product-card__wishlist');
    const savedWishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

    // Mark buttons as active if product is in wishlist
    wishlistButtons.forEach(function(btn) {
      const productId = btn.dataset.productId;
      if (savedWishlist.includes(productId)) {
        btn.classList.add('active');
      }
    });
  }

  // Handle wishlist button clicks using event delegation
  function handleWishlistClick(event) {
    const btn = event.target.closest('.product-card__wishlist');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const productId = btn.dataset.productId;
    if (!productId) return;

    let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

    if (btn.classList.contains('active')) {
      wishlist = wishlist.filter(function(id) { return id !== productId; });
      btn.classList.remove('active');
    } else {
      if (!wishlist.includes(productId)) {
        wishlist.push(productId);
      }
      btn.classList.add('active');
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistButtons);
  } else {
    initWishlistButtons();
  }

  // Use event delegation on document body for click handling
  document.body.addEventListener('click', handleWishlistClick);

  // Re-initialize when new content is added (for infinite scroll, quick view, etc.)
  // Listen for Shopify section events
  document.addEventListener('shopify:section:load', initWishlistButtons);
})();
